import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getStoredSessionToken } from '@/contexts/session/sessionUtils';

const setAuthHeader = (headers, getState) => {
  const { security } = getState();
  if (security) {
    const { securityToken } = security;
    if (securityToken) {
      headers.set('Boletia-Authorization', `Bearer ${securityToken}`);
    }
  }

  if (typeof window !== 'undefined') {
    const sessionToken = getStoredSessionToken();
    if (sessionToken) {
      headers.set('X-Session-Token', sessionToken);
    }
  }

  return headers;
};

const authBaseQuery = (params) => {
  const rawBaseQuery = fetchBaseQuery({
    baseUrl: params.baseUrl,
    prepareHeaders: (headers, api) =>
      params.prepareHeaders
        ? params.prepareHeaders(setAuthHeader(headers, api.getState), api)
        : setAuthHeader(headers, api.getState),
  });

  const prepareUrlDefault = (state, endpoint, url) => url;

  const authResponseBaseQuery = async (args, api, extraOptions) => {
    const state = api.getState();
    const { security } = state;
    const urlEnd = typeof args === 'string' ? args : args.url;

    if (
      process.env.NEXT_PUBLIC_USE_SECURITY === 'true' &&
      !security &&
      !security.securityToken
    ) {
      return {
        error: {
          status: 400,
          statusText: 'Bad Request',
          data: { message: 'No security token received' },
        },
      };
    }

    const adjustedUrl = params.prepareUrl
      ? params.prepareUrl(state, api.endpoint, urlEnd)
      : prepareUrlDefault(state, api.endpoint, urlEnd);

    if (adjustedUrl && adjustedUrl.error) {
      return adjustedUrl;
    }

    const adjustedArgs =
      typeof args === 'string' ? adjustedUrl : { ...args, url: adjustedUrl };

    let result = await rawBaseQuery(adjustedArgs, api, extraOptions);

    return result;
  };

  return authResponseBaseQuery;
};

export { authBaseQuery };
